module.exports = __webpack_public_path__ + "static/media/Fades.8d14676d.png";